<template>
  <div class="card">
    <div class="card-image" v-if="$slots.image">
      <slot name="image"></slot>
    </div>
    <div class="row ml-0" v-if="$slots.header || title">
      <div class="card-header">
        <slot name="header">
          <h4 class="card-title">{{title}}</h4>
          <p class="card-subtitle">{{subtitle}}</p>
        </slot>
      </div>
      <div class="ml-auto mt-3 mr-4">
        <slot name="corner"></slot>
      </div>
    </div>
    <div class="card-body">
      <slot></slot>
    </div>
    <div class="card-footer" v-if="$slots.footer">
      <hr>
      <slot name="footer"></slot>
    </div>
  </div>
</template>
<script>
  export default {
    name: 'card',
    props: {
      title: String,
      subtitle: String
    }
  }
</script>

<style>
</style>
